import { createI18n } from 'vue-i18n'
import { localeEn, localeMe, localeSr, localeBa } from 'app-resources';

const messages = { en: localeEn, me: localeMe, sr: localeSr, ba: localeBa };

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages,
  missingWarn: false
});

export default i18n;
